import React, { useState, useEffect } from 'react';
import { syncService } from '../../services/sync';
import './SyncStatusIndicator.css';

interface SyncStatusIndicatorProps {
  receiptId?: string;
  clientVersion?: number;
  serverVersion?: number;
}

const SyncStatusIndicator: React.FC<SyncStatusIndicatorProps> = ({ receiptId, clientVersion = 0, serverVersion = 0 }) => {
  const [isSyncing, setIsSyncing] = useState<boolean>(false);

  useEffect(() => {
    const updateStatus = () => {
      if (receiptId) {
        // Перевірити чи синхронізується зараз
        const syncing = syncService.isSyncing(receiptId);
        setIsSyncing(syncing);
      } else {
        setIsSyncing(false);
      }
    };

    updateStatus();
    
    // Підписатися на зміни статусу синхронізації
    const unsubscribe = syncService.onStatusChange(updateStatus);
    
    // Також оновлювати через інтервал для надійності
    const interval = setInterval(updateStatus, 500);
    
    return () => {
      unsubscribe();
      clearInterval(interval);
    };
  }, [receiptId]);

  // Перевірити чи є локальні зміни які очікують синхронізації (clientVersion > serverVersion)
  const hasPendingSync = clientVersion > serverVersion && receiptId && clientVersion > 0 && serverVersion > 0;

  // Показувати індикатор якщо синхронізується або є локальні зміни які очікують синхронізації
  if (!isSyncing && !hasPendingSync) {
    return null;
  }

  return (
    <div className="sync-status-wrapper">
      {isSyncing ? (
        <div className={`sync-status-indicator syncing visible`}>
          <div className="sync-spinner"></div>
          <span className="sync-status-text">Синхронізація...</span>
        </div>
      ) : hasPendingSync ? (
        <div className={`sync-status-indicator pending visible`}>
          <span className="sync-status-text">Очікує синхронізації</span>
        </div>
      ) : null}
    </div>
  );
};

export default SyncStatusIndicator;
